import { Translation } from "@/data/lang";

import { ButtonGroupProps } from "ui/core/button-group";

export const getIntervalButtonsData = ({
  t,
}: {
  t: Translation;
}): ButtonGroupProps["options"] => [
  { id: "annual", name: t.analysis.value.factor.interval.annual },
  { id: "quarter1", name: t.analysis.value.factor.interval.quarter1 },
  { id: "quarter4", name: t.analysis.value.factor.interval.quarter4 },
];

export type ValueFactorInterval = "annual" | "quarter1" | "quarter4";
